import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import chartPreview from './orderFillsByVenueCapsulePreview.png';

export const orderFillsByVenueCapsuleDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                This capsule displays your order&apos;s breakdown of execution
                venues that it has traded in.
            </div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            title: 'Chart',
            src: chartPreview,
            altText: 'order-fills-by-venue-capsule-chart-preview',
        },
    ],
};
